import Cookies from "js-cookie";

import {
  AD_ENTRY_INTENT_COOKIE_KEY,
  type EntryIntent,
  isEntryIntent,
  resolveEntryIntent,
} from "./adSource";
import {
  getEntryIntentFromStore,
  setEntryIntentInStore,
} from "./adSourceStore";

/**
 * 落点意图读写（EDG-543，语义见 `adSource.ts` 的 `ENTRY_INTENT_BY_SOURCE`）。
 *
 * 两个写入点，都只来自**本次**入口：
 * - web 浏览器落地：Proxy 把 URL 上的 `ad_source` 落成一次性 cookie（`OnboardingStepGate`）；
 * - 原生深链：`captureAdSourceFromDeepLink` 调 {@link captureEntryIntent} 写内存。
 * 后端 `track_meta.ad_source` 回填**不得**调用本模块，否则回填值会重新触发落点。
 */
export function captureEntryIntent(adSource: string | null | undefined): void {
  const intent = resolveEntryIntent(adSource);
  if (adSource) {
    consumeEntryIntent();
    setEntryIntentInStore(intent);
  }
}

/**
 * 「广告落点」类意图（chat / etf_overlap）：登录后都要**绕开 onboarding**、落到各自的承接页。
 * entry gate 里原先写死 `=== "chat"` 的两处判断（sessionTheme 放行、`/onboarding` 页守卫）统一读这里，
 * 否则 ETF 重叠的广告用户恰好在 /onboarding 完成登录时会被钉在 wizard（RK-10）。
 */
export function isAdLandingIntent(intent: EntryIntent | null): boolean {
  return intent === "chat" || intent === "etf_overlap";
}

/** 当前待执行的落点意图；不消费。 */
export function peekEntryIntent(): EntryIntent | null {
  const fromStore = getEntryIntentFromStore();
  if (fromStore || typeof document === "undefined") {
    return fromStore;
  }
  const fromCookie = Cookies.get(AD_ENTRY_INTENT_COOKIE_KEY)?.trim();
  return isEntryIntent(fromCookie) ? fromCookie : null;
}

/** 落点已执行后调用：内存与 cookie 一并清除，二次打开回默认流程。 */
export function consumeEntryIntent(): void {
  setEntryIntentInStore(null);
  if (typeof document !== "undefined") {
    Cookies.remove(AD_ENTRY_INTENT_COOKIE_KEY, { path: "/" });
  }
}
